/*
.. Modified by Kishore Jalleda
.. full list of modifications at https://github.com/unstructai
.. copyright: (c) 2023 Kishore Jalleda
.. author:: Kishore Jalleda <kjalleda@gmail.com>
*/
import API from "@/api"

const resource = "iaos"

export default {
  addResource(incidentId, payload) {
    return API.post(`/${resource}/${incidentId}/add-resource`, payload)
  },

  getAll(options) {
    return API.get(`/${resource}`, {
      params: { ...options },
    })
  },

  get(incidentId) {
    return API.get(`/${resource}/${incidentId}`)
  },

  getMetricForecast(options) {
    return API.get(`/${resource}/metric/forecast`, {
      params: { ...options },
    })
  },

  create(payload) {
    return API.post(`/${resource}`, payload)
  },

  update(incidentId, payload) {
    return API.put(`/${resource}/${incidentId}`, payload)
  },

  bulkUpdate(incidents, payload) {
    return Promise.all(
      incidents.map((incident) => {
        return this.update(incident.id, { ...incident, ...payload })
      })
    )
  },

  delete(incidentId) {
    return API.delete(`/${resource}/${incidentId}`)
  },

  bulkDelete(incidents) {
    return Promise.all(
      incidents.map((incident) => {
        return this.delete(incident.id)
      })
    )
  },

  join(incidentId, payload) {
    return API.post(`/${resource}/${incidentId}/join`, payload)
  },

  subscribe(incidentId, payload) {
    return API.post(`/${resource}/${incidentId}/subscribe`, payload)
  },

  createReport(incidentId, type, payload) {
    return API.post(`/${resource}/${incidentId}/report/${type}`, payload)
  },

  addComment(incidentId, payload) {
    return API.post(`/${resource}/${incidentId}/comments/add`, payload)
  },
  createPostmortemReport(incidentId) {
    return API.post(`/${resource}/${incidentId}/postmortem/create`)
  },
  getSimilar(incidentId) {
    return API.get(`/${resource}/similar-incidents/${incidentId}`)
  },
  createNewEvent(incidentId, payload) {
    return API.post(`/${resource}/${incidentId}/event`, payload)
  },

  updateEvent(incidentId, payload) {
    return API.patch(`/${resource}/${incidentId}/event`, payload)
  },

  deleteEvent(incidentId, event_uuid) {
    return API.delete(`/${resource}/${incidentId}/event/${event_uuid}`)
  },
  markStable(incidentId) {
    return API.post(`/${resource}/${incidentId}/stable`)
  },
  markClosed(incidentId) {
    return API.post(`/${resource}/${incidentId}/closed`)
  }
}
